import { useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  fetchFavouriteTemplates,
  toggleTemplateFavouriteStatus,
} from "../thunks";

import { useIsFavourite } from "./useSelectors";
import { TemplateId } from "../../../globalTypes";

export const useFavouriteTemplatesFetcher = () => {
  const dispatch = useDispatch();
  return () => dispatch(fetchFavouriteTemplates());
};

export const useFavouriteStatusToggler = () => {
  const dispatch = useDispatch();

  const toggler = (templateId: TemplateId, isFavourite: boolean) =>
    dispatch(toggleTemplateFavouriteStatus(templateId, isFavourite));

  return useCallback(toggler, [dispatch]);
};

export const useToggleTemplateFavouriteStatus = (templateId: TemplateId) => {
  const dispatch = useDispatch();
  const isFavourite = useIsFavourite(templateId);
  return () => dispatch(toggleTemplateFavouriteStatus(templateId, isFavourite));
};
